import React, { useState } from 'react';
const faqs = [{
  q: 'È adatto a Hatha e Vinyasa?',
  a: 'Sì, il sistema include sequenze sia statiche che dinamiche, con varianti specifiche per Hatha, Vinyasa e Yoga Terapeutico.'
}, {
  q: 'Ricevo i bonus con il prezzo di €19?',
  a: "Sì, è tutto incluso nel pacchetto se acquisti ora durante l'offerta di lancio. I 6 bonus esclusivi (valore €49) sono totalmente gratuiti."
}, {
  q: "Posso usarlo se sono un'insegnante alle prime armi?",
  a: "Assolutamente. Ti darà la struttura che spesso manca all'inizio, con sequenze progressive dal livello base all'avanzato e linee guida pedagogiche chiare."
}, {
  q: 'In che formato ricevo il materiale?',
  a: 'PDF ad alta risoluzione, ottimizzati per essere letti su tablet o smartphone, oppure stampati in formato A4 da portare in sala. Non serve alcun software speciale.'
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì, utilizziamo gateway criptati e sicuri al 100%. Accettiamo carte di credito, debito e i principali metodi di pagamento italiani.'
}, {
  q: 'Per quanto tempo ho accesso al materiale?',
  a: 'Accesso a vita. Una volta scaricato, il kit è 100% tuo per sempre — senza abbonamenti, senza pagamenti ricorrenti, senza scadenze.'
}, {
  q: "C'è una garanzia di rimborso?",
  a: 'Sì, hai 7 giorni di garanzia totale. Se non ti convince, ti restituiamo il 100% dei tuoi soldi senza domande e senza procedure complicate.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-137">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-16" data-id="element-138">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-139">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-140">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-141">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-142">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-143">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-144">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-145">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-146"></div>
          <a href="#pricing" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Yoga Pronta — Il Kit Completo',
              content_type: 'product',
              value: 19,
              currency: 'EUR'
            });
          }
        }} className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-147">
            🚀 SÌ! VOGLIO ELEVARE IL MIO INSEGNAMENTO ORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-148">
            <span data-id="element-149">⚡ Accesso Immediato</span>
            <span data-id="element-150">•</span>
            <span data-id="element-151">🛡️ Garanzia di 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}